/**
 * Management → Communication Setup。
 * 打开页面打 STATSIG.COMMON.VIEW，value=mgmt_communication_setup。
 * Settings 同一组件 value=settings_communication_setup。
 *
 * 正在用：
 * - 点 Set up 打开邮箱弹窗
 * - Individual Connect / 系统通知 Finish：value 为填写的邮箱
 * - 旧版 Team email 点 Connect：value 为填写的管理员邮箱
 * - 确认后 Remove
 * - SMS 开关立刻落库
 *
 * 已不算：Learn more、Skip、成功页继续配系统通知、新 Team Connect（TODO）。
 * Settings 是同一组件，不另开一套事件。
 */
export enum MgmtCommunicationSetupEvent {
    /**
     * 点 Set up 打开邮箱弹窗。
     * value 与 metadata.type 相同：click_open_popup
     */
    EMAIL_SETUP_BUTTON = 'COMMUNICATION_SETUP_EMAIL_SETUP_BUTTON',
    /**
     * Individual Connect / 系统通知 Finish。
     * value 与 metadata.email 相同，为用户填写的邮箱
     */
    CONNECT = 'COMMUNICATION_SETUP_CONNECT',
    /**
     * 旧版 Team email 点 Connect。
     * value 与 metadata.email 相同，为用户填写的管理员邮箱
     */
    TEAM_EMAIL = 'COMMUNICATION_SETUP_TEAM_EMAIL',
    /**
     * 确认后删除邮箱。
     * 属性 type=individual|system
     */
    REMOVE = 'COMMUNICATION_SETUP_REMOVE',
    /**
     * SMS notifications 开关。
     * 属性 enabled=true|false
     */
    SMS_NOTIF_SWITCH = 'COMMUNICATION_SETUP_SMS_NOTIF_SWITCH',
}
